import React, {useEffect, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import classnames from "classnames";
import Switch from "@mui/material/Switch";
import CustomCurrencyInput from "../../../../components/CustomCurrencyInput";
import Button from "@mui/material/Button";
import {useDealContext} from "../../../../contexts/DealContext";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../../../HomePage/HomePage";


const initialState = {
    id: '',
    name: '',
    amount: null,
    is_capped: false,
    is_taxed: true,
    is_tax_capped: false,
}

function getRandomSixDigit() {
    // Range is from 100000 to 999999
    return Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
}

export const DealPageCreateCustomFee = ({dealState, setDealStateWithUpdate, isLoading, isTabletOrMobile, isCappingDisabled, isEditingDisabled}) => {
    const { updateDealResponse } = useDealContext()

    const getInitialFeeState = () => {
        return {...initialState, id: String(getRandomSixDigit())}
    }

    const [state, setState] = useState(getInitialFeeState())
    const isDisabled = Boolean(!state?.name) || Boolean(!state?.amount)

    const isFinanced = state?.is_capped

    const addFee = () => {
        let newDealState = structuredClone(dealState)
        const allFees = dealState.formatted_quote.fees
        newDealState.formatted_quote.fees = allFees.concat(state)
        setDealStateWithUpdate(newDealState, true)
    }

    useEffect(function resetInitialStateAfterFeeCreate(){
        if (updateDealResponse?.data?.data && !updateDealResponse.loading && !updateDealResponse.error) {
            const newDealState = updateDealResponse?.data?.data
            const fees = newDealState.formatted_quote.fees

            if (fees.some(f => String(f.id) === String(state.id))) {
                setState(getInitialFeeState())
            }
        }
    }, [updateDealResponse])

    if (!state) return null;

    return (
        <TableRow
            key={'DealPageCreateCustomFee'}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        // justifyContent: 'end',
                    }}
                >
                    <input
                        className=""
                        type="text"
                        value={state.name}
                        placeholder={isTabletOrMobile ? "Custom" : "Custom Fee Name"}
                        onChange={(e) => setState({...state, name: e.target.value})}
                        style={{
                            width: isTabletOrMobile ? '75px' : 'auto'
                        }}
                    />
                    <Button
                        disabled={isDisabled}
                        className={classnames('CustomFee-button', {
                            disabled: isLoading
                        })}
                        onClick={addFee}
                    >
                        {isTabletOrMobile ? "Add" : "Click to Add Custom Fee"}
                    </Button>
                </div>
            </TableCell>
            <TableCell
                className={'DealPageFee'}
                align="right"
                size={'small'}
                width={'20%'}
            >
                {
                    !isCappingDisabled &&
                    <Switch
                        disabled={isLoading}
                        checked={state.is_capped}
                        onChange={() => {
                            const newCappedState = !state.is_capped
                            setState({...state, is_capped: newCappedState, is_tax_capped: newCappedState})
                        }}
                    />
                }
            </TableCell>
            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'60%'}
            >
                <CustomCurrencyInput
                    onChange={(value) => setState({...state, amount: value})}
                    className={classnames('payment-row_value custom-fee-input', {
                        mobileBlue: isTabletOrMobile && isFinanced,
                        loading: isLoading
                    })}
                    prefix="$"
                    value={state.amount}
                    key={'CustomFee'}
                    allowNull={true}
                    disabled={isEditingDisabled}
                    InputProps={isTabletOrMobile ? {} : undefined}
                />
            </TableCell>
        </TableRow>
    )
}